// @ts-nocheck
import { sasInputStyles } from "@store/Themes/sas/mixins";

export default {
    defaultProps: {
        cssOverrides: {
            inputSelect: sasInputStyles(),
        },
    },
};
